import { z } from 'zod';

import { emailSchema, phoneNumberSchema, zipCodeSchema } from '@/lib/validation-schemas';

const shippingAddressFormId = 'shipping-address-form';
const shippingAddressFormSchema = z.object({
  addressLine1: z.string().min(1, 'Please make a selection'),
  addressLine2: z.string(),
  city: z.string().min(1, 'Please make a selection'),
  state: z.string().min(1, 'Please make a selection'),
  zip: zipCodeSchema,
});

type ShippingAddressFormData = z.infer<typeof shippingAddressFormSchema>;

// For Me form schema
const forMeFormId = 'for-me-form';
const forMeFormSchema = z.object({
  ...shippingAddressFormSchema.shape,
  phoneNumber: phoneNumberSchema,
  email: emailSchema,
});

type ForMeFormData = z.infer<typeof forMeFormSchema>;

// For Someone Else - Contact Info form schema
const forSomeoneElseFormId = 'for-someone-else-form';
const forSomeoneElseFormSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phoneNumber: phoneNumberSchema,
  email: emailSchema,
});

type ForSomeoneElseFormData = z.infer<typeof forSomeoneElseFormSchema>;

// Relationship form schema
const relationshipFormId = 'relationship-form';
const relationshipOptions = [
  { value: 'family-member', label: 'Family member' },
  { value: 'non-family-caregiver', label: 'Non-family caregiver' },
] as const;

const relationshipFormSchema = z.object({
  relationship: z.enum(
    relationshipOptions.map((option) => option.value),
    {
      message: 'Please make a selection',
    }
  ),
  authorizedForMedicalDecisions: z.enum(['yes', 'no'], {
    message: 'Please make a selection',
  }),
});
type Relationship = z.infer<typeof relationshipFormSchema.shape.relationship>;

type RelationshipFormData = z.infer<typeof relationshipFormSchema>;

export type Contact = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  relationship?: Relationship;
  authorizedForMedicalDecisions?: boolean;
};

export type {
  ShippingAddressFormData,
  ForMeFormData,
  ForSomeoneElseFormData,
  RelationshipFormData,
};
export {
  shippingAddressFormId,
  shippingAddressFormSchema,
  forMeFormId,
  forMeFormSchema,
  forSomeoneElseFormId,
  forSomeoneElseFormSchema,
  relationshipFormId,
  relationshipFormSchema,
  relationshipOptions,
};
